@import 'styles/variables';
@import 'styles/mixins';

.tadaPng {
  height: 48px;
  width: 48px;
  margin-bottom: 64px;
}

.problemText {
  font-size: 24px;
}

.verificationMessage {
  text-align: center;
  padding: 20px 0;
  word-break: break-all;
  color: $red-50;
}

.continueButton {
  padding: 0 20px;
  margin: 0;
}

.leftPanel {
  display: flex;
  flex-direction: column;
}

.leftContent {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  width: 100%;
  margin-top: -50px;
}

.title {
  margin-bottom: 0px;
}

.subTitle {
  margin-bottom: 0px;

  p {
    margin-bottom: 0px;
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-top: 36px;
}
